/**
 * @author Shalini Jha
 * @name RichTextEditor
 * @desc A component that renders a rich text editor.
 * React quill is used for this component.
 * The output generated by this component is HTML element
 * Images are base64 encoded
 */
import React from 'react';
import ReactQuill, { Quill } from 'react-quill'; // import * as QuillNamespace from 'quill';
// let Quill = QuillNamespace;

import ImageResize from 'quill-image-resize-module-react';
import PropTypes from 'prop-types';
import 'react-quill/dist/quill.snow.css';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import './RichTextEditor.css';
const { DialogActions } = MaterialUiCore;
const { DialogTitle } = MaterialUiCore;
const { DialogContent } = MaterialUiCore;
const { Dialog } = MaterialUiCore;
const { TextField } = MaterialUiCore;
Quill.register('modules/imageResize', ImageResize);

const RichTextEditor = ({
    title,
    editorData,
    onChangeHandler,
    fullScreen,
    docTitle,
    setDocTitle,
    editorActions,
    closeEditor,
}) => {
    // const classes = useStyles();
    const [showEditor, setShowEditor] = React.useState(true);
    const modules = {
        toolbar: [
            [
                {
                    header: '1',
                },
                {
                    header: '2',
                },
                {
                    font: [],
                },
            ],
            [
                {
                    size: [],
                },
            ],
            [
                {
                    align: [],
                },
            ],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [
                {
                    list: 'ordered',
                },
                {
                    list: 'bullet',
                },
                {
                    indent: '-1',
                },
                {
                    indent: '+1',
                },
            ],
            ['link', 'image'],
            ['clean'],
        ],
        imageResize: {
            modules: ['Resize', 'DisplaySize', 'Toolbar'],
        },
    };
    const formats = [
        'header',
        'font',
        'size',
        'align',
        'bold',
        'italic',
        'underline',
        'strike',
        'blockquote',
        'list',
        'bullet',
        'indent',
        'link',
        'image',
    ];
    return (
        <>
            {fullScreen ? (
                <Dialog fullScreen open={showEditor}>
                    <DialogTitle id="alert-dialog-title">
                        <div className="modalTitle">
                            <span>{title}</span>
                            <span
                                onClick={() => {
                                    setShowEditor(false);
                                    closeEditor();
                                }}
                                className="sct-icons icon-Remove-18 icon-text-18"
                            />
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <TextField
                            type="text"
                            label="Title"
                            className="fullWidth"
                            variant="outlined"
                            value={docTitle}
                            onChange={setDocTitle}
                        />

                        <ReactQuill
                            className="quillEditor"
                            theme="snow"
                            modules={modules}
                            formats={formats}
                            value={editorData}
                            onChange={onChangeHandler}
                        />
                    </DialogContent>
                    <DialogActions className="dialogActions">{editorActions}</DialogActions>
                </Dialog>
            ) : (
                <>
                    <ReactQuill
                        className="quillEditor"
                        theme="snow"
                        modules={modules}
                        formats={formats}
                        value={editorData}
                        onChange={onChangeHandler}
                    />
                    <div>{editorActions}</div>
                </>
            )}
        </>
    );
};

RichTextEditor.defaultProps = {
    fullScreen: false,
};
RichTextEditor.propTypes = {
    title: PropTypes.string.isRequired,
    editorData: PropTypes.string.isRequired,
    onChangeHandler: PropTypes.func.isRequired,
    fullScreen: PropTypes.bool,
    docTitle: PropTypes.string.isRequired,
    setDocTitle: PropTypes.func.isRequired,
    editorActions: PropTypes.element.isRequired,
    closeEditor: PropTypes.func.isRequired,
};
export default RichTextEditor;
